import { render, staticRenderFns } from "./DataDictionary.vue?vue&type=template&id=e7738a1c&scoped=true&"
import script from "./DataDictionary.vue?vue&type=script&lang=js&"
export * from "./DataDictionary.vue?vue&type=script&lang=js&"
import style0 from "./DataDictionary.vue?vue&type=style&index=0&id=e7738a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7738a1c",
  null
  
)

export default component.exports